import React, { useMemo } from "react";
import { Line } from "@react-three/drei";
import type { OrbitalElements } from "../../types/celestialBody";
import type { VisualizationScale } from "../../types/astronomy";
import { sampleOrbit } from "../../astronomy/orbitalPosition";
import { astronomicalToThree } from "../../astronomy/coordinateSystems";

interface OrbitPathProps {
  orbit: OrbitalElements;
  scale: VisualizationScale;
  color?: string;
  sampleCount?: number;
  parentOffsetScene?: [number, number, number];
}

export function OrbitPath({
  orbit,
  scale,
  color = "#5a7a9a",
  sampleCount = 256,
  parentOffsetScene = [0, 0, 0],
}: OrbitPathProps) {
  const points = useMemo(() => {
    const samples = sampleOrbit(orbit, sampleCount);
    const s = scale.distanceScale;
    const [ox, oy, oz] = parentOffsetScene;
    const verts = samples.map((p) => {
      const t = astronomicalToThree(p);
      return [
        t.x * s + ox,
        t.y * s + oy,
        t.z * s + oz,
      ] as [number, number, number];
    });
    if (verts.length > 0) verts.push(verts[0]);
    return verts;
  }, [
    orbit,
    scale.distanceScale,
    sampleCount,
    parentOffsetScene[0],
    parentOffsetScene[1],
    parentOffsetScene[2],
  ]);

  return (
    <Line
      points={points}
      color={color}
      transparent
      opacity={0.45}
      lineWidth={1}
    />
  );
}
